import FloatingCourseActionsBar from '@/components/FloatingCourseActionsBar';
import GoBackMenu from '@/components/GoBackNavbar';
import Tab from '@/components/Tab';
import { ApplicationState } from '@/store';
import { clearQuiz } from '@/store/quiz/action';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import QuizInfo from './Info';
import CreateQuizQuestionaireScreen from './Questionaire';
import CreateQuizResultScreen from './Result';
import './style.scss';

const ManageQuiz: React.FC = () => {
    const { id } = useParams<{ id: string }>();

    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const history = useHistory();

    const dispatch = useDispatch();

    const manageQuizBasePath = '/contents/buzz/tests';

    useEffect(() => {
        return () => {
            dispatch(clearQuiz());
        };
    }, [dispatch]);

    return (
        <>
            <div className="create-quiz">
                <GoBackMenu confirmable goBackPath={manageQuizBasePath} />
                <div className="title">
                    <h1>{id ? strings.EDIT_QUIZ : strings.NEW_QUIZ}</h1>
                </div>
                <div className="create-quiz__container">
                    <div className="tabs-container">
                        <Tab
                            active={!history.location.pathname.match(/(results|questions|publication)/)}
                            setActive={() => id && history.push(`${manageQuizBasePath}/${id}`)}
                            title={strings.GENERAL_DATA}
                        />
                        <Tab
                            active={history.location.pathname.indexOf('results') > -1}
                            disabled={!id}
                            setActive={() => id && history.push(`${manageQuizBasePath}/${id}/results`)}
                            title={strings.RESULTS}
                        />
                        <Tab
                            active={history.location.pathname.indexOf('questions') > -1}
                            disabled={!id}
                            setActive={() => id && history.push(`${manageQuizBasePath}/${id}/questions`)}
                            title={strings.QUESTIONS}
                        />
                    </div>

                    <div className="quiz-content">
                        <Switch>
                            <Route exact path={`${manageQuizBasePath}/:id/questions`}>
                                <CreateQuizQuestionaireScreen />
                            </Route>
                            <Route exact path={`${manageQuizBasePath}/:id/results`}>
                                <CreateQuizResultScreen />
                            </Route>
                            <Route exact path={`${manageQuizBasePath}/:id`}>
                                <QuizInfo />
                            </Route>
                            <Route exact path={manageQuizBasePath}>
                                <QuizInfo />
                            </Route>
                        </Switch>
                    </div>
                </div>
                <FloatingCourseActionsBar />
            </div>
        </>
    );
};

export default ManageQuiz;
